import { Link } from 'react-router-dom';
import ScrollLink from '@/components/base/ScrollLink';

export default function Footer() {
  return (
    <footer className="bg-axelia-footer-bg text-axelia-footer-text relative overflow-hidden">
      {/* Background decorative text */}
      <div className="absolute bottom-0 left-0 right-0 pointer-events-none select-none overflow-hidden">
        <span className="block text-[120px] md:text-[200px] lg:text-[280px] font-serif font-bold text-white/[0.03] leading-none tracking-tighter">
          AXELIA
        </span>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 pt-16 md:pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* CTA Area */}
          <div className="lg:col-span-1">
            <h3 className="font-serif text-xl md:text-2xl font-semibold text-white mb-4 leading-snug">
              人と組織の成長に、
              <br />
              確かな支援を
            </h3>
            <p className="text-sm text-axelia-footer-muted leading-relaxed mb-6">
              人材育成コンサルティングからシステム構築まで、
              <br />
              実務に根ざした支援で未来を創造します。
            </p>
            <Link
              to="/"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="inline-flex items-center gap-2 text-sm font-medium text-axelia-accent-light hover:text-white transition-colors duration-300"
            >
              <span>トップページへ</span>
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-5 tracking-wide">ナビゲーション</h4>
            <ul className="flex flex-col gap-3">
              <li>
                <Link
                  to="/"
                  className="text-sm text-axelia-footer-muted hover:text-white transition-colors duration-300"
                >
                  トップページ
                </Link>
              </li>
              <li>
                <ScrollLink
                  to="#services"
                  className="text-sm text-axelia-footer-muted hover:text-white transition-colors duration-300"
                >
                  事業紹介
                </ScrollLink>
              </li>
              <li>
                <ScrollLink
                  to="#about"
                  className="text-sm text-axelia-footer-muted hover:text-white transition-colors duration-300"
                >
                  会社概要
                </ScrollLink>
              </li>
              <li>
                <ScrollLink
                  to="#contact"
                  className="text-sm text-axelia-footer-muted hover:text-white transition-colors duration-300"
                >
                  お問い合わせ
                </ScrollLink>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-sm text-axelia-footer-muted hover:text-white transition-colors duration-300"
                >
                  プライバシーポリシー
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-5 tracking-wide">連絡先</h4>
            <ul className="flex flex-col gap-3 text-sm text-axelia-footer-muted">
              <li>
                <a
                  href="mailto:customer@axelia-tech.com"
                  className="inline-flex items-center gap-2.5 hover:text-white transition-colors duration-300 break-all"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-mail-line text-base" />
                  </span>
                  customer@axelia-tech.com
                </a>
              </li>
              <li>
                <a
                  href="tel:0368217456"
                  className="inline-flex items-center gap-2.5 hover:text-white transition-colors duration-300"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-phone-line text-base" />
                  </span>
                  03-6821-7456
                </a>
              </li>
              <li>
                <div className="inline-flex items-start gap-2.5">
                  <span className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-map-pin-line text-base" />
                  </span>
                  <span>〒104-0041 東京都中央区八丁堀3丁目15番6-509号</span>
                </div>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-5 tracking-wide">会社情報</h4>
            <div className="space-y-3 text-sm text-axelia-footer-muted">
              <p>会社名: AXELIA株式会社</p>
              <p>代表者: 松葉 崇紘</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-axelia-footer-muted">
            &copy; {new Date().getFullYear()} AXELIA株式会社. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/privacy-policy"
              className="text-xs text-axelia-footer-muted hover:text-white transition-colors duration-300"
            >
              プライバシーポリシー
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
